import { yupResolver } from '@hookform/resolvers/yup'
import { Button } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import React, { useContext } from 'react'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'

import ContentHelp from '@flatsy/core/Content/Help'
import { REGEX } from '@flatsy/core/Form/ReactFormHooks/Field/Constant'
import FlatsyTextField from '@flatsy/core/Form/ReactFormHooks/Field/Text'
import { Body1, Body2 } from '@flatsy/core/MaterialUi/Typo'
import { Controller, useForm } from 'react-hook-form'

import { FileContext } from '../../Files/Context'
import { useStyles } from './Style'

interface CheckEmailProps {
  validateEmail: (inputEmail: string) => void
}

interface FormData {
  email: string
}

const CheckEmail: React.FC<CheckEmailProps> = ({ validateEmail }) => {
  const classes = useStyles()
  const i18n = useTranslation()
  const {
    applicants: { current },
  } = useContext(FileContext)

  const schema = yup.object({
    email: yup
      .string()
      .email(i18n.t('the_email_address_entered_does_not_match_the_correct_formatting'))
      .matches(
        REGEX.email,
        i18n.t('the_email_address_entered_does_not_match_the_correct_formatting')
      )
      .required(),
  })

  const {
    control,
    handleSubmit,
    formState: { isSubmitSuccessful, isValid, isDirty },
  } = useForm<FormData>({
    mode: 'all',
    resolver: yupResolver(schema),
  })

  const onSubmit = async (data: FormData) => {
    validateEmail(data.email)
  }

  return (
    <div className={classes.content}>
      <ContentHelp icon={<InfoOutlinedIcon />} severity="info">
        {i18n.t('send_code_to_email_address')}
      </ContentHelp>
      <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <div className={classes.inputContent}>
          <Body1>{i18n.t('indicate_email_address_to_apply')}</Body1>
          <Controller
            name="email"
            control={control}
            render={({ field, fieldState }) => (
              <FlatsyTextField
                label={i18n.t('your_email_address')}
                type="text"
                {...field}
                {...fieldState}
                isSubmitSuccessful={isSubmitSuccessful}
              />
            )}
          />
          <div className={classes.hint}>
            <Body2>
              {i18n.t('hint')} : {current?.email}
            </Body2>
          </div>
        </div>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.continueButton}
          disabled={!isValid || !isDirty}
        >
          {i18n.t('continue')}
        </Button>
      </form>
    </div>
  )
}

export default CheckEmail
